import { identity } from 'ramda'

import type { Request } from '../../../index'


export const convertResult = identity

export const GET_ACCOUNT_CROSS_AUTH_TOKEN: Request<void, string, void> = [
  'account/tokens/cross_auth',
  'get',
  ['data', 'token'],
]
